const initialStateSearch = {
    users_search: []
};

export default initialStateSearch;